import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHorizontalDividerCheck = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 10 2",
	...props,
	children: /* @__PURE__ */ _jsx("line", {
		x1: 1,
		y1: 1,
		x2: 9,
		y2: 1,
		stroke: "#4F31FF",
		strokeWidth: 2,
		strokeLinecap: "round"
	})
});
export default SvgHorizontalDividerCheck;
